import React from 'react';
import MakeOwner from '../organizations/make_owner.jsx'
import DeleteUser from '../organizations/delete_user.jsx'

class ModifyUser extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{display: "inline"}}>
          <MakeOwner {...this.props} />
          <DeleteUser {...this.props} />
      </div>
    );
  }
}

module.exports = ModifyUser;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/organizations/modify_user.jsx